// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/marketing_consent/firstparty/v1/get_client_consents.proto

/* oxlint-disable */

/** Identifies a specific type of marketing consent. */
export const ApiConsentId = {
  /** CONSENT_ID_UNSPECIFIED - Unspecified consent ID, used as a default/fallback value. */
  CONSENT_ID_UNSPECIFIED: "CONSENT_ID_UNSPECIFIED",
  /**
   * newsletter - Consent for newsletter communications.
   */
  newsletter: "newsletter",
  /**
   * product_updates - Consent for product update communications.
   */
  product_updates: "product_updates",
  /**
   * offers - Consent for promotional offers.
   */
  offers: "offers",
  /**
   * partner - Consent for partner communications.
   */
  partner: "partner",
  /**
   * feedback - Consent for feedback requests.
   */
  feedback: "feedback",
  /**
   * referrals - Consent for referral program communications.
   */
  referrals: "referrals",
} as const;

export type ApiConsentId = typeof ApiConsentId[keyof typeof ApiConsentId];

export namespace ApiConsentId {
  export type CONSENT_ID_UNSPECIFIED = typeof ApiConsentId.CONSENT_ID_UNSPECIFIED;
  export type newsletter = typeof ApiConsentId.newsletter;
  export type product_updates = typeof ApiConsentId.product_updates;
  export type offers = typeof ApiConsentId.offers;
  export type partner = typeof ApiConsentId.partner;
  export type feedback = typeof ApiConsentId.feedback;
  export type referrals = typeof ApiConsentId.referrals;
}

export function apiConsentIdFromJSON(object: any): ApiConsentId {
  switch (object) {
    case 0:
    case "CONSENT_ID_UNSPECIFIED":
      return ApiConsentId.CONSENT_ID_UNSPECIFIED;
    case 1:
    case "newsletter":
      return ApiConsentId.newsletter;
    case 2:
    case "product_updates":
      return ApiConsentId.product_updates;
    case 3:
    case "offers":
      return ApiConsentId.offers;
    case 4:
    case "partner":
      return ApiConsentId.partner;
    case 5:
    case "feedback":
      return ApiConsentId.feedback;
    case 6:
    case "referrals":
      return ApiConsentId.referrals;
    default:
      return ApiConsentId.CONSENT_ID_UNSPECIFIED;
  }
}

export function apiConsentIdToJSON(object: ApiConsentId): string {
  switch (object) {
    case ApiConsentId.CONSENT_ID_UNSPECIFIED:
      return "CONSENT_ID_UNSPECIFIED";
    case ApiConsentId.newsletter:
      return "newsletter";
    case ApiConsentId.product_updates:
      return "product_updates";
    case ApiConsentId.offers:
      return "offers";
    case ApiConsentId.partner:
      return "partner";
    case ApiConsentId.feedback:
      return "feedback";
    case ApiConsentId.referrals:
      return "referrals";
    default:
      return "CONSENT_ID_UNSPECIFIED";
  }
}

/** Represents a single marketing consent entry for a client. */
export interface ApiConsent {
  /** The consent identifier. */
  readonly id: ApiConsentId;
  /** Whether the client has opted in to this consent type. */
  readonly value: boolean;
}

/** Request message for retrieving all marketing consents for the authenticated client. */
export interface ApiGetClientConsentsRequest {
}

/** Response message containing the current marketing consent preferences. */
export interface ApiGetClientConsentsResponse {
  /** The list of marketing consents for the client. */
  readonly consents: readonly ApiConsent[];
}

export const ApiConsent: MessageFns<ApiConsent> = {
  fromJSON(object: any): ApiConsent {
    return {
      id: isSet(object.id) ? apiConsentIdFromJSON(object.id) : ApiConsentId.CONSENT_ID_UNSPECIFIED,
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: ApiConsent): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = apiConsentIdToJSON(message.id);
    }
    if (message.value !== undefined && message.value !== null) {
      obj.value = message.value;
    }
    return obj;
  },
};

export const ApiGetClientConsentsRequest: MessageFns<ApiGetClientConsentsRequest> = {
  fromJSON(_: any): ApiGetClientConsentsRequest {
    return {};
  },

  toJSON(_: ApiGetClientConsentsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetClientConsentsResponse: MessageFns<ApiGetClientConsentsResponse> = {
  fromJSON(object: any): ApiGetClientConsentsResponse {
    return {
      consents: globalThis.Array.isArray(object?.consents)
        ? object.consents.map((e: any) => ApiConsent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiGetClientConsentsResponse): unknown {
    const obj: any = {};
    if (message.consents?.length) {
      obj.consents = message.consents.map((e) => ApiConsent.toJSON(e));
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
